<template>
<div class="ems-handware-products-page">
   <el-tabs v-model="activeName"  @tab-click="handleClick" type="card" id="fixed-nav" stretch>
      <el-tab-pane v-for="(item, index) in hardwares" :name="'tab'+index" :key="index" :label="item.title" class="container-fluid-fixed">
        <ul>
          <li :class="['item', {'flex-reverse': index2%2==0?false:true}]" v-for="(item2, index2) in item.item" :key="index2">
            <div class="text">
              <h2>{{item2.title}}</h2>
              <ul>
                <li v-for="(item3, index3) in item2.text" :key="index3"><i class="tick"></i><span>{{item3.subcontent}}</span></li>
              </ul>
            </div>
            <img :src="item2.img" alt="" class="hardware-image">
          </li>
        </ul>
      </el-tab-pane>
    </el-tabs>
</div>
</template>
<script>
import TitleBar from './TitleBar.vue'
import img1 from '../assets/高速扫描仪.jpg'
import img2 from '../assets/高拍仪.jpg'
import img3 from '../assets/A4扫描仪.jpg'
import img4 from '../assets/A3高速扫描仪.jpg'
import img5 from '../assets/pda手持机.jpg'
import img6 from '../assets/RFID手持机.jpg'
import img7 from '../assets/档案盒打印机.jpg'
import img8 from '../assets/RFID打印机.jpg'
import img9 from '../assets/GP-2134T标签打印机.jpg'
import img10 from '../assets/RFID工业打印机.jpg'
import img11 from '../assets/桌面式发卡器.jpg'
import img12 from '../assets/rfid发卡器.jpg'
import img13 from '../assets/四通道超高频读写器.jpg'
import img14 from '../assets/八通道超高频读写器.jpg'
import img15 from '../assets/亚银不干胶标签.jpg'
import img16 from '../assets/UHF INLAY.jpg'
import img17 from '../assets/UHF LED RFID标签.jpg'
import img18 from '../assets/超高频.jpg'
import img19 from '../assets/密集架.jpg'
import img20 from '../assets/智能密集架.jpg'
import img21 from '../assets/智能档案柜.jpg'
import img22 from '../assets/超高频RFID安全门禁.jpg'
import img23 from '../assets/耐高温管理标签.jpg'
import img24 from '../assets/rfid抗金属.jpg'
import img25 from '../assets/超高频柔性.jpg'
import img26 from '../assets/点检仪.jpg'
import img27 from '../assets/压力传感器.jpg'
import img28 from '../assets/无线温度传感器.jpg'
import img29 from '../assets/温湿度传感器.jpg'


import { get, imageFile } from '../plugins/request.js'
import getQueryString from '../plugins/getQueryString.js'

export default {
  name: 'EmsHandwareProductsPage',
  components: {
    TitleBar
  },
  data() {
    return {
      activeName: 'tab0',
      hardwares:[{"title":"打印设备",
                 "item":[{"img":img10,"title":"RFID工业打印机","text":[{"subcontent":"热敏/热转印的打印方式"},{"subcontent":"上下反射式\/穿透式(均可移动)的纸张探测方式"},{"subcontent":"具备功能: 集成的UHF读写器\/编码器(EPC Class 1 Gen 2\/ISO 18000-6C)"}]},
                         {"img":img8,"title":"RFID打印机","text":[{"subcontent":"分辨率 300dpi(12点\/毫米)"},{"subcontent":"打印方式 热敏或热转印"},{"subcontent":"打印速度 168mm\/s"}]},
                         {"img":img9,"title":"GP-2134T标签打印机","text":[{"subcontent":"操作简单 自动测纸 快速出纸 稳定打印"},{"subcontent":"打印清晰 寿命长久 大容量纸仓 超宽出纸"},{"subcontent":"6inch\/s高速度打印，300DPI高精度打印"}]},
                         {"img":img7,"title":"移动便携式蓝牙打印机","text":[{"subcontent":"机身重量：0.7KG"},{"subcontent":"分辨率：300dpi"},{"subcontent":"打印接口：蓝牙,USB,WIFI"}]}]},
                 {"title":"手持终端",
                 "item":[{"img":img5,"title":"PDA手持机","text":[{"subcontent":"操作系统：Android 8.1"},{"subcontent":"处理器：4核1.3GHz"},{"subcontent":"内存：2GRAM+16GROM"}]},
                         {"img":img6,"title":"RFID超高频手持机","text":[{"subcontent":"基于ARM Cortex-A73⾼端旗舰⼋核CPU，主频2.0GHz"},{"subcontent":"5.5⼨IPS⾼清显⽰屏，18:9⽐例设计"},{"subcontent":"卓越的超⾼频读写功能，室外读距⾼达20⽶"},{"subcontent":"采⽤⾃研⾼性能四壁螺旋圆极化天线"}]}]},
                {"title":"读写器",
                "item":[{"img":img11,"title":"桌面式发卡器","text":[{"subcontent":"内置M-500微型超高频模块"},{"subcontent":"支持USB供电或外置9V独立电源供电"},{"subcontent":"读取距离:80~300CM (测试标签：lmpinj E41b inlay)"},{"subcontent":"支持USB 2.0\/ RS-232\/ 韦根 26\/ 韦根 34"}]},
                        {"img":img12,"title":"RFID发卡器","text":[{"subcontent":"支持国际上流行的ISO18000-6C空中接口协议标准"},{"subcontent":"超强的多标签读写性能，提高转换、借还效率"},{"subcontent":"具有EPC标签匹配和重复标签过滤功能"},{"subcontent":"密集型阅读模式"}]},
                        {"img":img13,"title":"四通道超高频读写器","text":[{"subcontent":"双CPU架构设计，快速4天线轮询功能，两种标签盘存模式"},{"subcontent":"实现18000-6B\/C全协议功能，大数据一次性读写"},{"subcontent":"天线连接状态监测"}]},
                        {"img":img14,"title":"八通道超高频读写器","text":[{"subcontent":"基于Impinj性能优异的专用UHF RFID芯片，具有独一无二的I-Serch多标签识别算法"},{"subcontent":"快速4天线轮询功能"},{"subcontent":"实现18000-6B/C全协议功能，大数据一次性读写"}]}]},
                {"title":"资产标签",
                "item":[{"img":img15,"title":"亚银不干胶标签","text":[{"subcontent":"防水防油，多种规格可选"},{"subcontent":"尺寸参考：60×30×1000张/卷，60×40×1000张/卷"}]},
                        {"img":img16,"title":"UHF INLAY","text":[{"subcontent":"芯片：Alien\/Higgs3；NXP U Code 7；Impinj\/Monze 4E"},{"subcontent":"由PET材料和铝组成的含有芯片及线圈层合在一起的预层压产品"}]},
                        {"img":img17,"title":"UHF LED RFID标签","text":[{"subcontent":"LED发光：指定TID的标签点亮"},{"subcontent":"出色性能：高效的多标签防冲突算法实现高效群读、快速点亮"},{"subcontent":"通用设计：适合标签复合生产"},{"subcontent":"超远的读写工作距离：标签读写距离可达8米"}]},
                         {"img":img25,"title":"超高频柔性可打印抗金属标签","text":[{"subcontent":"解决了普通抗金属标签不能附着于不规则或曲面的金属上使用的难题"},{"subcontent":"抗金属电子标签贴在金属上具有良好的读取性能"},{"subcontent":"符合 EPC C1G2（ISO 18000-6C）标准，可以上RFID打印机"}]},
                        {"img":img24,"title":"RFID抗金属电子标签","text":[{"subcontent":"无源UHF抗金属标签，远距离识别，性价比高，坚固耐用"},{"subcontent":"可用于：工具追踪、医疗设备管理、仪器追踪、生产流水线设备、IT/电信管理"}]},
                        {"img":img23,"title":"耐高温RFID电子标签","text":[{"subcontent":"耐高温抗金属标签安装方式灵活，可以采用铆钉安装、螺丝安装，也可以采用能经受安装环境的双面胶、或强力胶安装"},{"subcontent":"此标签在可靠性上能经受：高温测试、高低温交变测试、酸碱测试、振动测试、超声波洗涤测试"}]}]},
                {"title":"其他设备",
                "item":[{"img":img22,"title":"超高频RFID安全门禁","text":[{"subcontent":"智能安全门禁，符合ISO18000-6C（EPC C1G2）协议，支持多标签读取"},{"subcontent":"采用红外触发读取模式，支持进出人数统计"},{"subcontent":"集成声光报警为一体，可使用在线/离线EAS报警两种模式"},{"subcontent":"设备支持网口通信，并可拓展WiFi、4G等多种通讯方式"}]},
                        {"img":img26,"title":"温振一体点检仪","text":[{"subcontent":"体积小重量轻，手持式便于携带"},{"subcontent":"可靠和快速的无线数据传输"},{"subcontent":"支持温度、振动检测数据上传"}]},
                        {"img":img27,"title":"无线压力传感器","text":[{"subcontent":"低功耗设计，锂电池供电"},{"subcontent":"免除布线施工 ，安装维护方便"},{"subcontent":"无线传输，多种移动信号可选"},{"subcontent":"抗干扰能力强、信号稳定，覆盖范围广"}]},
                        {"img":img28,"title":"无线温度传感器","text":[{"subcontent":"采样速率1Hz～4kHz，数据存储空间4M"},{"subcontent":"数据存储空间4M，温度测量-40℃ ～ 85℃"},{"subcontent":"数据按需采集，可设置采集计划"},{"subcontent":"传输有效距离>5000m"}]},
                        {"img":img29,"title":"无线温湿度传感器","text":[{"subcontent":"支持多种环境参数检测"},{"subcontent":"支持配置采样发送间隔"},{"subcontent":"支持LoRaWan和LinkWan协议"},{"subcontent":"设计精巧、更低功耗"}]},
                ]}]
    }
  },
  methods: {
    handleClick(){

    },
    watchScroll() {
      // 滚动的距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      
      // 容器的高度
     
      var offsetTop = document.querySelector("#fixed-nav>.el-tabs__header").offsetTop
      const fixedHigh = document.querySelector("#fixed-nav").offsetTop
      //console.log(offsetTop)
      //判断window滚动条上下滚动
      const scrollDir = scrollTop - this.scroolI
      this.scroolI = scrollTop;
      //console.log(scrollTop,offsetTop,scrollDir,fixedHigh)
      //  滚动的距离如果大于了元素到顶部的距离时，实现吸顶效果
      if(scrollDir>0){
        if(scrollTop > offsetTop){
          document.querySelector("#fixed-nav>.el-tabs__header").classList.add("navBarFixed")
          document.querySelector("#fixed-nav").style.paddingTop='65px'
        }else{
          document.querySelector("#fixed-nav>.el-tabs__header").classList.remove("navBarFixed")
          document.querySelector("#fixed-nav").style.paddingTop=''
        }
        // this.navBarFixed = scrollTop > offsetTop ? true : false;
      }else{
        if(scrollTop > fixedHigh){
          document.querySelector("#fixed-nav>.el-tabs__header").classList.add("navBarFixed")
          document.querySelector("#fixed-nav").style.paddingTop='65px'
        }else{
          document.querySelector("#fixed-nav>.el-tabs__header").classList.remove("navBarFixed")
          document.querySelector("#fixed-nav").style.paddingTop=''
        }
        //this.navBarFixed = scrollTop > fixedHigh ? true : false;
      }
   
    },
  },
  created: function(){
   
  },
  watch: {
    
  },
  mounted() {
    // 事件监听滚动条
    window.addEventListener("scroll", this.watchScroll);
  },
  unmounted() {
    // 移除事件监听
    window.removeEventListener("scroll", this.watchScroll);
  },
}
</script>
<style lang="scss">
.ems-handware-products-page{
    background: #F8F9FD;
    padding-top: 6rem;
    .item {
      padding: 2.5rem 7.5rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 2.5rem;
      background: #fff;
      border-radius: 6px;
      img{
        width: 400px;
      }
      &.flex-reverse{
        flex-direction: row-reverse;
      }
      .text{
        h2{
          font-size: 1.8rem;
          font-weight: normal;
          margin-bottom: 2rem;
          color: #444;
        }
        ul{
          li{
            font-size: 0.8rem;
            color: #666666;
            margin-bottom: 1rem;
            display: flex;
            span{
              line-height: 1.7;
              max-width: 320px;
              display: inline-block;
            }
            .tick{
              background: url('../assets/list-point.png') no-repeat;
              width: 17px;
              height: 17px;
              display: inline-block;
              margin-right: 1rem;
              margin-top: 6px;
              background-size: 90%;
            }
          }
        }
      }
      .hardware-image{
        
      }
    }
    
    .navBarFixed{
      position: fixed;
      left:0;
      top: 0;
      z-index: 999;
      width: 100%;
    }
     .el-tabs__nav-next, .el-tabs__nav-prev{
      line-height: 3.4rem;
      font-size: 16px;
    }
    .el-tabs--card > .el-tabs__header{
      border: none;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__nav{
      border: none;
      padding-right: 10%;
      padding-left: 10%;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__item.is-active{
      border: none;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__item{
      border-left: none;
      font-size: 0.8rem;
      padding: 0 20px;
      height: 2.2rem;
      line-height: 2.4rem;
      border-radius: 1.5rem;
      transition: none;
    }
    .el-tabs__item.is-active{
      background-color: #2a7acc;
      color: #fff;
    }
    
    .el-tabs__nav-wrap{
      background: #F8F9FD;
    }
    .el-tabs__nav-scroll{
      padding: 18px 0;
      background: #F8F9FD;
    }
    .container-fluid-fixed{
      max-width: 60rem;
      margin: 40px auto;
      padding: 1rem 1rem 2rem 1rem;
    }
    .el-tabs__content{
      margin-top: 2rem;
    }
    .el-tab-pane{
      //display: block !important;
    }
  }
</style>